import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export type LegalSection = {
  title: string;
  paragraphs?: string[];
  items?: string[];
};

interface LegalPageProps {
  seoTitle: string;
  seoDescription: string;
  keywords: string;
  url: string;
  title: string;
  sections: LegalSection[];
  contactTitle: string;
  contactIntro: string;
  contactLines: string[];
  updated: string;
}

const LegalPage = ({
  seoTitle,
  seoDescription,
  keywords,
  url,
  title,
  sections,
  contactTitle,
  contactIntro,
  contactLines,
  updated,
}: LegalPageProps) => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <SEO title={seoTitle} description={seoDescription} keywords={keywords} url={url} />

      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-primary mb-8 text-center">{title}</h1>

          {sections.map((section) => (
            <Card key={section.title} className="shadow-medium mb-8">
              <CardHeader>
                <CardTitle>{section.title}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                {(section.paragraphs ?? []).slice(0, 1).map((p) => (
                  <p key={p} className="text-muted-foreground">
                    {p}
                  </p>
                ))}
                {(section.items ?? []).length > 0 && (
                  <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                    {(section.items ?? []).map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
                {(section.paragraphs ?? []).slice(1).map((p) => (
                  <p key={p} className="text-muted-foreground">
                    {p}
                  </p>
                ))}
              </CardContent>
            </Card>
          ))}

          <Card className="shadow-medium">
            <CardHeader>
              <CardTitle>{contactTitle}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-muted-foreground">{contactIntro}</p>
              <p className="text-muted-foreground">
                {contactLines.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>
              <p className="text-sm text-muted-foreground mt-4">{updated}</p>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalPage;
